export const mapObjValues =
  <T, R>(fn: (value: T, key: string) => R) =>
  (obj: Record<string, T>): Record<string, R> =>
    Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, fn(value, key)]));
